import React, { useEffect, useRef } from 'react';
import './painel-admin.component.scss';
import { Button } from '@mui/material';
import ConteudoPainelMenuComponent from '../conteudo-painel-menu/conteudo-painel-menu.component';
import SiteModel, { ComponentsModel, CopiasSitesModel } from '../../models/layout.model';
import SaveIcon from '@mui/icons-material/Save';
import MenuModel from '../../models/menu.model';
import ConteudoPainelFooterComponent from '../conteudo-painel-footer/conteudo-painel-footer.component';
import FooterModel from '../../models/footer.model';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import WhatsAppModel from '../../models/whatsapp.model';
import ConteudoPainelWhatsappComponent from '../conteudo-painel-whatsapp/conteudo-painel-whatsapp.component';
import CookiesModel from '../../models/cookies.model';
import ConteudoPainelAvisoCookiesComponent from '../conteudo-painel-aviso-cookies/conteudo-painel-aviso-cookies.component';
import ConteudoPainelComponentesComponent from '../conteudo-painel-componentes/conteudo-painel-componentes.component';
import { LoadingService } from '../../services/loading.service';
import { AtualizaSiteService, GetSiteService, InsereSiteService, SaveSiteService } from '../../services/api-pages.service';
import { SnackService } from '../../services/snack.service';
import UsuarioModel from '../../models/usuario.model';
import { getAuthUser } from '../../services/auth';
import { environment } from '../../environments/environment';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VerifiedIcon from '@mui/icons-material/Verified';

import { GetApp } from '@mui/icons-material';
import ModalCopiaComponent from '../modal-copia/modal-copia.component';

export type PainelAdminComponentProps = {
  site?: SiteModel;
  setSite: (value: SiteModel) => void;
  setCopiaEmProducao?: (value: string) => void;
  isCopia: boolean;
  idCopia?: string;
  idCopiaEmProd?: string;
}

function PainelAdminComponent(props: PainelAdminComponentProps) {

  const [menu, setMenu] = React.useState<MenuModel>();
  const [footer, setFooter] = React.useState<FooterModel>();
  const [whatsapp, setWhatsapp] = React.useState<WhatsAppModel>();
  const [cookies, setCookies] = React.useState<CookiesModel>();
  const [componentes, setComponentes] = React.useState<ComponentsModel[]>();
  const [menuAtivo, setMenuAtivo] = React.useState<string>('menu');
  const [listSite, setListSite] = React.useState<SiteModel>();
  const [usuarioLogado, setUsuarioLogado] = React.useState<UsuarioModel>(getAuthUser());

  const [isBtSalvar, setIsBtSalvar] = React.useState<boolean>(false);
  const [isSalvarEmProd, setIsSalvarEmProd] = React.useState<boolean>(false);
  const [openModalCopia, setOpenModalCopia] = React.useState<boolean>(false);
  const [nomeCopia, setNomeCopia] = React.useState<string>('');


  const salvaComTimeout: any = useRef(null);

  const SalvarSite = () => {
    setIsBtSalvar(true);
    SalvarPainelService.sendSalvar(true);
    LoadingService.sendLoadingAtivo(true);
  };

  useEffect(() => {
    clearTimeout(salvaComTimeout.current);
    salvaComTimeout.current = setTimeout(() => { SalvarSiteVerificacao() }, 500);
  }, [
    menu,
    footer,
    whatsapp,
    cookies,
    componentes
  ]);

  useEffect(() => {
    if (props.isCopia) {
      setListSite(props.site);
      setMenu(props.site?.menu);
      if (props.site) {
        props.setSite(props.site);
      }
    } else {
      GetSite();
    }
  }, [])

  const GetSite = () => {
    LoadingService.sendLoadingAtivo(true);
    GetSiteService({ ID: usuarioLogado.site_id }).then(res => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        setListSite(res.data);
        setMenu(res.data.menu);
        props.setSite(res.data);
      }
    }).catch(err => {
      SnackService.sendMSG('Erro com a conexão.');
      LoadingService.sendLoadingAtivo(false);
      console.log(err);
    });
  }

  const SalvarSiteVerificacao = () => {
    if (props.isCopia && props.idCopia) {
      if (isSalvarEmProd) {
        SalvarSiteNoAdmin();
      } else if (nomeCopia) {
        InserirCopiaNoAdmin();
      } else if (listSite?.copias?.length === 1) {
        if (listSite.copias[0].post_id) {
          AtualizaCopiaNoAdmin(listSite.copias[0].post_id);
        }
      } else if (props.idCopia) {
        AtualizaCopiaNoAdmin(props.idCopia);
      } else {
        SalvarSiteNoAdmin();
      }
    } else {
      InserirCopiaNoAdmin();
    }
  }

  const SalvarSiteNoAdmin = () => {

    if (!isBtSalvar) {
      return;
    }

    let dto: SiteModel = {
      id: usuarioLogado.site_id,
      copia_em_producao: props.idCopia ? parseInt(props.idCopia) : undefined,
      menu: menu,
      footer: footer,
      whatsapp: whatsapp,
      aviso_cookies: cookies,
      components: componentes
    };

    LoadingService.sendLoadingAtivo(true);
    SaveSiteService(dto).then(res => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        // setListSite(res.data);
        // setMenu(res.data.menu);
        // setFooter(res.data.footer);
        SnackService.sendMSG(res.data);
        setIsBtSalvar(false);
        setNomeCopia('');
        if (isSalvarEmProd && props.setCopiaEmProducao) {
          props.setCopiaEmProducao(props.idCopia ? props.idCopia : '');
        }
        setIsSalvarEmProd(false);
      }
    }).catch(err => {
      SnackService.sendMSG('Erro com a conexão.');
      LoadingService.sendLoadingAtivo(false);
      console.log(err);
    });
  };

  const InserirCopiaNoAdmin = () => {

    if (!isBtSalvar) {
      return;
    }

    let dto: CopiasSitesModel = {
      label: nomeCopia ? nomeCopia : listSite?.menu?.nome_do_site,
      id: usuarioLogado.site_id,
      // json: JSON.stringify({
      //   id: usuarioLogado.site_id,
      //   menu: menu,
      //   footer: footer,
      //   whatsapp: whatsapp,
      //   aviso_cookies: cookies,
      //   components: componentes
      // }),
      menu: menu,
      footer: footer,
      whatsapp: whatsapp,
      aviso_cookies: cookies,
      components: componentes,
      post_id: '',
      post_author: usuarioLogado.ID,
      is_default: listSite?.copias ? false : true
    };

    LoadingService.sendLoadingAtivo(true);
    InsereSiteService(dto).then(res => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        SnackService.sendMSG(res.data);
        setIsBtSalvar(false);
        GetSite();
      }
    }).catch(err => {
      SnackService.sendMSG('Erro com a conexão.');
      LoadingService.sendLoadingAtivo(false);
      console.log(err);
    });
  };

  const AtualizaCopiaNoAdmin = (post_id: string) => {

    if (!isBtSalvar) {
      return;
    }

    let dto: CopiasSitesModel = {
      // json: JSON.stringify({
      //   id: usuarioLogado.site_id,
      //   menu: menu,
      //   footer: footer,
      //   whatsapp: whatsapp,
      //   aviso_cookies: cookies,
      //   components: componentes
      // }),
      post_id: post_id,
      menu: menu,
      footer: footer,
      whatsapp: whatsapp,
      aviso_cookies: cookies,
      components: componentes ? componentes : [],
    };

    LoadingService.sendLoadingAtivo(true);
    AtualizaSiteService(dto).then(res => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        SnackService.sendMSG(res.data);
        setIsBtSalvar(false);
        //GetSite();
      }
    }).catch(err => {
      SnackService.sendMSG('Erro com a conexão.');
      LoadingService.sendLoadingAtivo(false);
      console.log(err);
    });
  };

  return (
    <>
      {
        usuarioLogado.site_id ?
          <>
            {
              listSite ?
                <>
                  <section className="painel-admin">
                    <div className="topo-painel">
                      <h1>
                        {
                          listSite.menu?.logo.src &&
                          <img src={listSite.menu.logo.src} alt="Logo" />
                        }
                        <span>
                          Admin
                          <small>
                            {
                              listSite.menu?.nome_do_site
                            }
                            {
                              props.idCopiaEmProd?.toString() === props.idCopia?.toString() &&
                              <span>
                                <VerifiedIcon /> <b>Cópia usada em produção</b>
                              </span>
                            }
                          </small>
                        </span>
                      </h1>
                      <div className="dir">
                        {
                          ((listSite.copias && listSite.copias.length >= 1) || props.isCopia) &&
                          <Button className='bt copia' onClick={() => setOpenModalCopia(true)}><ContentCopyIcon /> Criar cópia</Button>
                        }
                        {
                          props.isCopia &&
                          <Button className='bt ver' href={environment.frontUrl + '?copiaID=' + props.idCopia} target='_blank'><RemoveRedEyeIcon /> Ver cópia</Button>
                        }
                        <Button className='bt ver' href={environment.frontUrl + '?siteID=' + usuarioLogado.site_id} target='_blank'><RemoveRedEyeIcon /> Ver site</Button>
                        {
                          props.isCopia &&
                          <Button className='bt usar-copia' onClick={() => {
                            setIsSalvarEmProd(true);
                            SalvarSite();
                          }}><VerifiedIcon /> Usar cópia</Button>
                        }
                        <Button className='bt salvar' onClick={SalvarSite}><SaveIcon /> Salvar</Button>
                      </div>
                    </div>
                    <div className="painel-a7apps">
                      <aside>
                        <Button className={menuAtivo === 'menu' ? 'ativo' : ''} onClick={() => setMenuAtivo('menu')}>Menu</Button>
                        <Button className={menuAtivo === 'footer' ? 'ativo' : ''} onClick={() => setMenuAtivo('footer')}>Footer</Button>
                        <Button className={menuAtivo === 'whatsapp' ? 'ativo' : ''} onClick={() => setMenuAtivo('whatsapp')}>Whatsapp</Button>
                        <Button className={menuAtivo === 'cookies' ? 'ativo' : ''} onClick={() => setMenuAtivo('cookies')}>Aviso cookies</Button>
                        <Button className={menuAtivo === 'componentes' ? 'ativo' : ''} onClick={() => setMenuAtivo('componentes')}>Componentes</Button>
                      </aside>
                      <div className="conteudo">
                        <div className={menuAtivo === 'menu' ? 'ativo' : ''}>
                          <ConteudoPainelMenuComponent setVal={(val) => setMenu(val)} menu={listSite?.menu} />
                        </div>
                        <div className={menuAtivo === 'footer' ? 'ativo' : ''}>
                          <ConteudoPainelFooterComponent setVal={(val) => setFooter(val)} footer={listSite?.footer} />
                        </div>
                        <div className={menuAtivo === 'whatsapp' ? 'ativo' : ''}>
                          <ConteudoPainelWhatsappComponent setVal={(val) => setWhatsapp(val)} whatsapp={listSite?.whatsapp} />
                        </div>
                        <div className={menuAtivo === 'cookies' ? 'ativo' : ''}>
                          <ConteudoPainelAvisoCookiesComponent setVal={(val) => setCookies(val)} cookies={listSite?.aviso_cookies} />
                        </div>
                        <div className={menuAtivo === 'componentes' ? 'ativo' : ''}>
                          {
                            menu &&
                            <ConteudoPainelComponentesComponent menu={menu?.itens ? menu.itens : []} setVal={(val) => setComponentes(val)} componentes={listSite?.components} />
                          }
                        </div>
                      </div>
                    </div>
                  </section>
                  <ModalCopiaComponent
                    open={openModalCopia}
                    onClose={() => setOpenModalCopia(false)}
                    criarCopia={(val) => {
                      setNomeCopia(val);
                      SalvarSite();
                      setOpenModalCopia(false);
                    }}
                  />
                </>
                :
                <p>Aguarde...</p>
            }
          </>
          :
          <>
            Nenhum site encontrado.
          </>
      }
    </>

  );
}

export default PainelAdminComponent;
